import { createAsyncThunk } from "@reduxjs/toolkit";
import { GraphQLClient } from "../../../../shared/gql-client";
import { gql } from "@apollo/client";

const IMPORT_PLATE_NUMBERS_MUTATION = gql`
  mutation ImportPlateNumbers($file: Upload!, $relationId: ID!) {
    importPlateNumbers(file: $file, relation_id: $relationId) {
      success
      message
      processed_count
      error_count
      errors {
        row
        column
        message
      }
    }
  }
`;

export interface ImportResult {
  success: boolean;
  message: string;
  processed_count: number;
  error_count: number;
  errors: Array<{
    row: number;
    column: string;
    message: string;
  }>;
}

export const importPlateNumbers = createAsyncThunk(
  "importPlateNumbers",
  async (props: { file: File; relationId: string }, thunkAPI) => {
    const { file, relationId } = props;
    const { client } = thunkAPI.extra as { client: GraphQLClient };

    try {
      return (await client.mutate(
        "importPlateNumbers",
        IMPORT_PLATE_NUMBERS_MUTATION,
        {
          file,
          relationId,
        },
      )) as ImportResult;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);
